export const useBodyOF = (type) => {
  const clear = () => {
    if (document.body.classList.contains("frzn"))
      document.body.classList.remove("frzn");
  };

  const on = () => {
    if (!document.body.classList.contains("frzn"))
      document.body.classList.add("frzn");
  };
  const off = () => {
    if (document.querySelectorAll(".modal").length == 1)
      document.body.classList.remove("frzn");
  };

  return { clear, on, off };
};
